import faker from '@faker-js/faker';
import loopMap from 'mn-utils/loopMap';
import {THistoryListItem, TOrdersListItem} from './types';

export const getReferralOrdersList = (limit: number): TOrdersListItem[] => {
  return loopMap(limit, () => {
    return getReferralOrdersDetails();
  });
};

export const getReferralOrdersDetails = (): TOrdersListItem => {
  return {
    id: faker.datatype.uuid(),
    retailer_name: faker.name.findName(),
    trx_count: faker.finance.amount(0, 1000, 2),
    amount: faker.finance.amount(0, 1000, 2),
    total: faker.finance.amount(0, 1000, 2),
    code: faker.finance.currencyCode(),
  } as TOrdersListItem;
};

export const getReferralHistoryList = (limit: number): THistoryListItem[] => {
  return loopMap(limit, () => {
    return getReferralHistoryDetails();
  });
};

export const getReferralHistoryDetails = (): THistoryListItem => {
  const statuses = ['completed', 'pending', 'failed', 'requested'];
  return {
    payment_id: faker.datatype.uuid(),
    retailer_name: faker.name.findName(),
    fiat_amount: faker.finance.amount(0, 1000, 2),
    fiat_code: faker.finance.currencyCode(),
    cc_amount: faker.finance.amount(0, 1000, 2),
    cc_code: faker.finance.currencyCode(),
    fee: faker.finance.amount(0, 1000, 2),
    transaction_status: (faker.helpers as any).arrayElement(statuses),
    date_time: faker.date.recent().toISOString()
  } as THistoryListItem;
};